var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('a',{staticClass:"btn-cu hover-shw",on:{"click":_vm.login}},[_c('span',{staticClass:"cl-claveunica"}),_c('span',{staticClass:"texto"},[_vm._v("Iniciar sesión")])])])}
var staticRenderFns = []

export { render, staticRenderFns }